import React from 'react';
import { useTranslation } from 'react-i18next';
import CommonOpenForOrdersField from '../../../common/fields/OpenForOrdersField';
import { ArtsAndCraftsDeviationFieldName } from '../../types';

const OpenForOrdersField: React.FC<{}> = () => {
  const { t } = useTranslation();

  return (
    <CommonOpenForOrdersField
      fieldName={ArtsAndCraftsDeviationFieldName.OPEN_FOR_ORDERS}
      label={t('artsAndCraftsDeviationPopup.form.openForOrders.label')}
      subLabel={t('artsAndCraftsDeviationPopup.form.openForOrders.subLabel')}
    />
  );
};
OpenForOrdersField.displayName = 'OpenForOrdersField';

export default OpenForOrdersField;
